import { getPath } from "../helpers/utils/getpath";
import getEndPoint from "../helpers/apiRequest";
import FourOhFourPage from "../views/FourOhFour";

// template pages
import DashboardView from "../views/dashboard";
import FullListView from "../views/lists";
// page helpers
import DashboardViewHelper from "../views/dashboard/helpers";

const Router = () => {
  const appContainer = document.querySelector(".main-content");
  const route = getPath();
  let resolver,
    loader = [];
  let delay = 200;
  let getdata = getEndPoint(route.page, route.subpage, route.params);
  document.querySelector(".site-navigation").classList.remove("showing");
  // load the requested template
  switch (route.page) {
    case "dashboard":
      resolver = DashboardView;
      loader = [DashboardViewHelper];
      break;
    case "list":
      resolver = FullListView;
      break;
    default:
      resolver = FourOhFourPage;
    //loader = [SnowFall];
  }

  getdata.then((data) => {
    //console.log(data);
    if (data.response != 200) {
      console.log("error");
      resolver = FourOhFourPage;
    }
    setTimeout(() => {
      try {
        resolver(data, route.page, route.subpage, route.params);
      } catch (err) {
        document.querySelector(".primary-header").classList.add("hide");
        resolver = FourOhFourPage;
        return true;
      }
      appContainer.innerHTML = resolver(
        data,
        route.page,
        route.subpage,
        route.params
      );

      [...loader].forEach((element) => {
        element(data, route.page, route.subpage);
      });
    }, delay);
  });
};

export default Router;
